import { render } from "./BaseMenu.vue?vue&type=template&id=423cc1e0&scoped=true"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"

import "./BaseMenu.vue?vue&type=style&index=0&id=423cc1e0&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423cc1e0"]])

export default __exports__